import { Component, OnDestroy, OnInit } from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { AulaVisualizacao } from 'src/app/models/aula-visualizacao';
import { ActivatedRoute } from '@angular/router';
import { AulaService } from 'src/app/services/aula/aula.service';
import { MessageUtil } from 'src/app/utils/message.util';
import { Location } from '@angular/common';
import { isUndefined } from 'lodash';
import { AulaOndeParou } from 'src/app/models/aula-onde-parou';

@Component({
  selector: 'app-sala-de-aula',
  templateUrl: './sala-de-aula.component.html',
  styleUrls: ['./sala-de-aula.component.scss'],
})
export class SalaDeAulaComponent implements OnInit, OnDestroy {
  @BlockUI() blockUI: NgBlockUI;
  aula = new AulaVisualizacao();
  aulaOndeParou: AulaOndeParou;

  constructor(private activatedRoute: ActivatedRoute, private aulaService: AulaService, public location: Location) {}

  ngOnDestroy(): void {
    if (!isUndefined(this.aula) && this.aula != null) {
      const videoAula = document.querySelector('#videoAula') as HTMLVideoElement;
      console.log('duração:', videoAula.duration);
      console.log('posição atual:', videoAula.currentTime);

      if (videoAula.currentTime >= videoAula.duration - 5) {
        // chama api para passar o valor "inativa" na lista dos cronogramas
        console.log('settando aula como inativa');
        this.setAulaInativa();
      }

      if (isNaN(videoAula.currentTime) || isUndefined(videoAula.currentTime)) {
        this.aula.continuarOndeParou = 0;
      } else if (videoAula.currentTime === this.aulaOndeParou.continuarOndeParou) {
        this.aula.continuarOndeParou = this.aulaOndeParou.continuarOndeParou;
        console.log(this.aula.continuarOndeParou = this.aulaOndeParou.continuarOndeParou);
      } else {
        this.aula.continuarOndeParou = videoAula.currentTime - 5;
      }

      // chamar api para salvar o tempo do video
      this.atualizarTempoOndeParou();
      console.log('última posição assistida salva:', this.aula.continuarOndeParou);
    }
  }

  ngOnInit() {
    this.activatedRoute.params.subscribe((params) => {
      console.log(params);
      if (params['id'] > 0) {
        this.aula.id = params.id;
        this.getAulaVisualizacao();
      } else {
        this.location.back();
      }
    });

    this.getAulaOndeParou();

    window.onbeforeunload = () => this.ngOnDestroy();

    // const videoAula = document.querySelector('#videoAula') as HTMLVideoElement;
    // videoAula.addEventListener(
    //   'loadedmetadata',
    //   function () {
    //     this.currentTime = 16.112363;
    //   },
    //   false
    // );
  }

  getAulaVisualizacao() {
    this.blockUI.start(MessageUtil.AGUARDE);
    this.aulaService.getAulaVisualizacao(this.aula.id).subscribe(
      (aula: AulaVisualizacao) => {
        this.blockUI.stop();
        this.aula = aula;
        // this.setCurrentTimeVideo(this.aula.continuarOndeParou);
        // console.log('ultima posição do vídeo assistida: ', this.aula.continuarOndeParou);
        // console.log('id próxima aula:', this.aula);
      },
      () => this.blockUI.stop()
    );
  }

  // setCurrentTimeVideo(continuarOndeParou: number) {
  //   const videoAula = document.querySelector('#videoAula') as HTMLVideoElement;

  //   videoAula.addEventListener(
  //     'loadedmetadata',
  //     function () {
  //       this.currentTime = continuarOndeParou;
  //     },
  //     false
  //   );
  // }

  getAulaOndeParou() {
    this.blockUI.start(MessageUtil.AGUARDE);

    this.aulaService.getAulaOndeParou().subscribe(
      (aulaOndeParou) => {
        this.blockUI.stop();
        this.aulaOndeParou = aulaOndeParou;

        const videoAula = document.querySelector('#videoAula') as HTMLVideoElement;
        videoAula.addEventListener(
          'loadedmetadata',
          function () {
            this.currentTime = aulaOndeParou.continuarOndeParou;
          },
          false
        );
        console.log('aula onde parou', this.aulaOndeParou.continuarOndeParou);
      },
      () => this.blockUI.stop()
    );
  }

  setAulaInativa() {
    // this.blockUI.start(MessageUtil.AGUARDE);
    // const dataLocalStorage = JSON.parse(localStorage.getItem('dataSelecionada'));
    // const currData = `${dataLocalStorage.ano}-${dataLocalStorage.mes + 1}-${dataLocalStorage.dia}`;

    // const planoLocalStorage = JSON.parse(localStorage.getItem('planoSelecionado'));
    this.aulaService.inativarAulaVisualizacao(this.aula.id);
    // this.aulaService.getAulasCronograma(planoLocalStorage.id, currData).subscribe(
    //   (cronogramas: any[]) => {
    //     this.blockUI.stop();
    //   },
    //   () => this.blockUI.stop()
    // );
  }

  atualizarTempoOndeParou() {
    const planoLocalStorage = JSON.parse(localStorage.getItem('planoSelecionado'));

    this.aulaService.salvarTempoOndeParou(planoLocalStorage.id, this.aula.id, this.aula).subscribe(
      (result) => {
        console.log('result atualizando: ' + result);
      },
      (err) => {
        console.log('error atualizar ' + err.error.message);
      }
    );
  }
}
